
import Tooltip from '@mui/material/Tooltip';

const TooltipC = ({ text, children, show }) => {
  return (
    <Tooltip title={text} open={show} arrow>
      <p>{children}</p>
    </Tooltip>
  );
};

export default TooltipC;
